var map = {
	"./1.png": 9990,
	"./2.png": 3885,
	"./3.png": 496,
	"./4.png": 6325,
	"./5.png": 9996,
	"./6.png": 4954,
	"./7.png": 5547,
	"./8.png": 6093,
	"./9.png": 2188
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4857;